import React, { useRef} from 'react';
import { useReactToPrint } from 'react-to-print';
import EnjoyNews from "./EnjoyNews";
import {useNavigate} from "react-router-dom";


const EnjoyNewsPDF = ({axis, close, years, pilots, weathers, tags, asideObjective, showKR}) => {
    const componentRef = useRef();
    const navigate = useNavigate();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "EnjoyNews",
        removeAfterPrint: true,
        onAfterPrint: () => {
            close();
        }
    });

    return (
        <div>
            <EnjoyNews ref={componentRef} handlePrint={handlePrint()} axis={axis} years={years} pilots={pilots}
                       weathers={weathers} tags={tags} asideObjective={asideObjective} showKR={showKR}/>
        </div>
    );
};

export default EnjoyNewsPDF